module.exports = __webpack_public_path__ + "img/numero-verde.a2c879db.png";